import { classTypes } from 'src/lib/constants'

import {
  USER_BASE_PLAN_ALL_FAVORITES,
  USER_BASE_PLAN_FAVORITE,
  USER_BASE_PLAN_UNFAVORITE,
  USER_PLAN_FAVORITES,
} from '../../lib/api-routes'
import { instance } from '../../lib/axiosInstance'

export const getFavoritePlans = async (email: string): Promise<unknown> => {
  const response = await instance.get(USER_PLAN_FAVORITES, {
    params: {
      userId: email.toLowerCase(),
    },
  })

  return response.data
}

export const getFavoriteBasePlans = async (email: string): Promise<unknown> => {
  const response = await instance.get(USER_BASE_PLAN_ALL_FAVORITES, {
    params: { userId: email.toLowerCase() },
  })

  return response.data
}

export interface FavoriteBasePlansParams {
  basePlan: string
  classType: classTypes
  email: string
}

const updateFavoriteBasePlan = async (
  url: string,
  { basePlan, classType, email }: FavoriteBasePlansParams
): Promise<unknown> => {
  const response = await instance.patch(url, {
    basePlan,
    classType,
    userId: email.toLowerCase(),
  })

  return response.data
}

export const addFavoriteBasePlans = (params: FavoriteBasePlansParams) =>
  updateFavoriteBasePlan(USER_BASE_PLAN_FAVORITE, params)

export const removeFavoriteBasePlans = (params: FavoriteBasePlansParams) =>
  updateFavoriteBasePlan(USER_BASE_PLAN_UNFAVORITE, params)
